import "../corralpagewrapper.css";
import React from "react";
import { useCurrentHeader } from "../../../../hooks/corral/currentHeader";

import { Card, Title } from "@mantine/core";
import HomePage from "../home-page/HomePage";

const QuickNavigateCard = () => {
  const { headerRef } = useCurrentHeader();
  return (
    <Card
      shadow="sm"
      padding="lg"
      radius="md"
      withBorder
      style={{ minHeight: "400px" }}
    >
      <Card.Section ref={headerRef} withBorder inheritPadding py="xs">
        <Title order={2} align="center">
          Quick Links
        </Title>
      </Card.Section>
      <HomePage />
    </Card>
  );
};

export default QuickNavigateCard;
